
import axiosAuthConfig from '../../axiosAuthConfig';

export const getProduct = async (id) => {
    try {
        const response = await axiosAuthConfig.get(`/api/products/${id}`); // Call your protected API endpoint
        return response.data; // Return the data from the response
    } catch (error) {
        console.log('Error fetching protected data:', error);
        // throw error; // Handle error appropriately
        
    }
};